import { render } from "./postHeader.vue?vue&type=template&id=6ae9abf2&scoped=true"
import script from "./postHeader.vue?vue&type=script&lang=js"
export * from "./postHeader.vue?vue&type=script&lang=js"

import "./postHeader.vue?vue&type=style&index=0&id=6ae9abf2&scoped=true&lang=scss"

import exportComponent from "D:\\wemet-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ae9abf2"]])

export default __exports__